<header class="app-header">
    @let headerStyles = $safeNavigationMigration(header()?.styles);
    @if (headerStyles) {
        <div [appCmsStyles]="headerStyles"></div>
    }

    <div class="tg-container app-header__inner">
        <a
            class="app-header__brand"
            [routerLink]="['/', lang()]"
            [attr.aria-label]="'core.header.brand' | translate"
        >
            @if (logo()?.url) {
                <cms-image
                    class="app-header__logo"
                    loading="eager"
                    sizes="152px"
                    [media]="logo()"
                    [fallbackAlt]="'core.header.brand' | translate"
                />
            } @else {
                <img
                    class="app-header__logo"
                    src="/assets/logo-tyme-group.svg"
                    [alt]="'core.header.brand' | translate"
                />
            }
        </a>

        <nav class="app-header__nav">
            @for (link of navLinks(); track link.id) {
                <cms-btn class="app-header__link" [config]="link" />
            }

            @let langName = 'core.header.language.' + lang() | translate;
            <button
                #langTrigger="matMenuTrigger"
                class="app-header__lang"
                type="button"
                mat-button
                [attr.aria-label]="'core.header.language.switcher' | translate: { language: langName }"
                [attr.aria-expanded]="langTrigger.menuOpen"
                [matMenuTriggerFor]="languageMenu"
            >
                <mat-icon>language</mat-icon>
                {{ langName }}
                <mat-icon
                    class="app-header__lang-caret"
                    [class.app-header__lang-caret--open]="langTrigger.menuOpen"
                >
                    arrow_drop_down
                </mat-icon>
            </button>
            <mat-menu #languageMenu="matMenu">
                @for (code of languages; track code) {
                    <button
                        type="button"
                        mat-menu-item
                        [disabled]="code === lang()"
                        (click)="switchLanguage(code)"
                    >
                        {{ 'core.header.language.' + code | translate }}
                    </button>
                }
            </mat-menu>
        </nav>

        <button
            class="app-header__burger"
            type="button"
            mat-icon-button
            [attr.aria-label]="'core.header.menu' | translate"
            [matMenuTriggerFor]="mobileMenu"
        >
            <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #mobileMenu="matMenu">
            @for (link of navLinks(); track link.id) {
                <cms-btn [config]="link" [menuItem]="true" />
            }
            <div class="app-header__menu-group-heading">{{ 'core.header.language.label' | translate }}:</div>
            <div class="app-header__menu-group">
                @for (code of languages; track code) {
                    <button
                        type="button"
                        mat-menu-item
                        [disabled]="code === lang()"
                        (click)="switchLanguage(code)"
                    >
                        {{ 'core.header.language.' + code | translate }}
                    </button>
                }
            </div>
        </mat-menu>
    </div>
</header>
